/**
 * Global JS
 *
 * Import JS that applies globally.
 */

import './js-enabled';
import './window-ready';
import './scroll-header';
import './scroll-to-top';
